import { b2ContactListener } from "../box2d_flash/runtime/index.js";

function isPlayerBody(body) {
  return body?.GetUserData?.()?.__kind === "player";
}

function addPlayerContact(listener, body) {
  if (body) {
    listener.playerContactBodies.push(body);
  }
}

// AS3 Bug: splice(_loc3_, 1) where _loc3_ is a b2Body object.
// AS3 coerces the object to int → 0, so it ALWAYS removes index 0
// (not the specific body). We replicate this exact behavior.
function removePlayerContact(listener, body) {
  if (listener.playerContactBodies.indexOf(body) !== -1) {
    listener.playerContactBodies.splice(0, 1);
  }
}

function bodiesFromContactPoint(contactPoint) {
  const bodyA = contactPoint?.shape1?.GetBody?.() ?? null;
  const bodyB = contactPoint?.shape2?.GetBody?.() ?? null;
  return [bodyA, bodyB];
}

export class MyContactListener extends b2ContactListener {
  constructor() {
    super();
    this.playerContactBodies = [];
  }

  get playerTouchingGround() {
    return this.playerContactBodies.length;
  }

  BeginContact(contact) {
    const bodyA = contact.GetFixtureA().GetBody();
    const bodyB = contact.GetFixtureB().GetBody();
    if (isPlayerBody(bodyA)) {
      addPlayerContact(this, bodyB);
    }
    if (isPlayerBody(bodyB)) {
      addPlayerContact(this, bodyA);
    }
  }

  EndContact(contact) {
    const bodyA = contact.GetFixtureA().GetBody();
    const bodyB = contact.GetFixtureB().GetBody();
    if (isPlayerBody(bodyA)) {
      removePlayerContact(this, bodyB);
    }
    if (isPlayerBody(bodyB)) {
      removePlayerContact(this, bodyA);
    }
  }

  Add(contactPoint) {
    const [bodyA, bodyB] = bodiesFromContactPoint(contactPoint);
    if (isPlayerBody(bodyA)) {
      addPlayerContact(this, bodyB);
    }
    if (isPlayerBody(bodyB)) {
      addPlayerContact(this, bodyA);
    }
  }

  Remove(contactPoint) {
    const [bodyA, bodyB] = bodiesFromContactPoint(contactPoint);
    if (isPlayerBody(bodyA)) {
      removePlayerContact(this, bodyB);
    }
    if (isPlayerBody(bodyB)) {
      removePlayerContact(this, bodyA);
    }
  }

  Persist() {}

  Result() {}
}
